import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import { LANG } from "../language/lang";

const PublicLayout = lazy(() => import('../layouts/PublicLayout'))
const CabinetLayout = lazy(() => import('../layouts/CabinetLayout'))
const AuthLayout = lazy(() => import('../layouts/AuthLayout'))
const ProtectedRoute = lazy(() => import('../routers/ProtectedRoute'))

const Home = lazy(() => import('../pages/Home'))
const Login = lazy(() => import('../pages/Auth/Login'))
const NotFound = lazy(() => import('../pages/NotFound'))
const About = lazy(() => import('../pages/About'))
const Contacts = lazy(() => import('../pages/Contacts'))
const Registration = lazy(() => import('../pages/Auth/Registration'))
const Profile = lazy(() => import('../pages/Cabinet/Profile/index.js'))
const Orders = lazy(() => import('../pages/Cabinet/Orders/index.js'))
const Balance = lazy(() => import('../pages/Cabinet/Balance/index.js'))
const History = lazy(() => import('../pages/Cabinet/History/index.js'))
const Proxy = lazy(() => import('../pages/Proxy'))
const FAQ = lazy(() => import('../pages/FAQ'))
const Pages = lazy(() => import('../pages/Pages'))

const ROUTE = [
    {
        path: '/',
        component: <PublicLayout />,
        componentName: 'PublicLayout',
        children: [
            {
                index: true,
                component: <Home />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_HOME"),
            },
            {
                path: 'about',
                component: <About />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_ABOUT"),
            },
            {
                path: 'faq',
                component: <FAQ />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_FAQ"),
            },
            {
                path: 'contacts',
                component: <Contacts />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_CONTACTS"),
            },
            {
                path: 'proxy',
                component: <Navigate to="/" replace />,
            },
            {
                path: 'proxy/ipv4',
                component: <Proxy />,
                menu: true,
                onlyMobile: true,
                secondary: true,
                title: LANG("MENU_CATEGORY_1"),
            },
            {
                path: 'proxy/ipv6',
                component: <Proxy />,
                menu: true,
                onlyMobile: true,
                secondary: true,
                title: LANG("MENU_CATEGORY_2"),
            },
            {
                path: 'proxy/isp',
                component: <Proxy />,
                menu: true,
                onlyMobile: true,
                secondary: true,
                title: LANG("MENU_CATEGORY_3"),
            },
            {
                path: 'proxy/resident',
                component: <Proxy />,
                menu: true,
                onlyMobile: true,
                secondary: true,
                title: LANG("MENU_CATEGORY_4"),
            },
            {
                path: 'proxy/mobile',
                component: <Proxy />,
                menu: true,
                onlyMobile: true,
                secondary: true,
                title: LANG("MENU_CATEGORY_5"),
            },
            {
                path: 'cookie-policy',
                component: <Pages />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_COOKIE_POLICY"),
            },

            {
                path: 'return-policy',
                component: <Pages />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_RETURN_POLICY"),
            },

            {
                path: 'privacy-policy',
                component: <Pages />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_RETURN_POLICY"),
            },

            {
                path: 'rules',
                component: <Pages />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_RETURN_POLICY"),
            },

            

        ],
    },
    {
        path: '/auth',
        componentName: 'AuthLayout',
        component: <AuthLayout />,
        children: [
            {
                path: 'login',
                component: <Login />,
            },
            {
                path: 'registration',
                component: <Registration />,
            },
        ],
    },
    {
        path: '/cabinet',
        component: <ProtectedRoute />,
        componentName: 'ProtectedRoute',
        children: [
            {
                component: <CabinetLayout />,
                componentName: 'CabinetLayout',
                children: [
                    {
                        index: true,
                        component: <Profile />,
                    },
                    {
                        path: 'profile',
                        component: <Profile />,
                    },
                    {
                        path: 'orders',
                        component: <Orders />,
                    },
                    {
                        path: 'balance',
                        component: <Balance />,
                    },
                    
                ],
            },
        ],
    },
    {
        path: '*',
        component: <NotFound />,
    },
]

export default ROUTE